import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { publicClient, customerClient } from "../api";
import { useI18n } from "../i18n";
import { Check, ChevronLeft } from "lucide-react";

export default function OrderSuccess() {
  const { slug } = useParams();
  const { t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sid = params.get("session_id");
    if (!sid) { navigate(`/r/${slug}`); return; }
    let cancelled = false;
    const poll = async (n) => {
      if (cancelled || n > 8) return;
      try {
        const { data } = await publicClient.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          // Try to redirect customer to live tracking page
          try {
            const oid = data.order_id || (data.metadata && data.metadata.order_id);
            if (oid && localStorage.getItem("foodgo_customer_token")) {
              try { sessionStorage.removeItem(`foodgo_cart_${slug}`); } catch { /* ignore */ }
              setTimeout(() => navigate(`/my-order/${oid}`, { replace: true }), 1200);
            }
          } catch { /* ignore */ }
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch (e) { /* ignore */ }
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Clear cart on success
  useEffect(() => {
    if (status === "paid") {
      try { sessionStorage.removeItem(`foodgo_cart_${slug}`); } catch { /* ignore */ }
    }
  }, [status, slug]);

  return (
    <div className="min-h-screen bg-deep flex items-center justify-center p-6">
      <div className="max-w-md text-center" data-testid="order-success-page">
        {status === "paid" ? (
          <>
            <div className="w-20 h-20 rounded-full bg-neon-cyan text-[#06061a] flex items-center justify-center mx-auto glow-cyan">
              <Check className="w-10 h-10" />
            </div>
            <h1 className="font-heading text-3xl mt-6">{t.storefront.successTitle}</h1>
            <p className="text-zinc-400 mt-2">{t.storefront.successDesc}</p>
            <Link to="/my-orders" className="btn-primary mt-6 inline-flex" data-testid="go-my-orders">{t.myOrders.title}</Link>
          </>
        ) : status === "expired" ? (
          <>
            <h1 className="font-heading text-3xl">Sessione scaduta</h1>
            <p className="text-zinc-400 mt-2">Riprova ad ordinare.</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full border-4 border-line border-t-[#00E5FF] animate-spin mx-auto" />
            <p className="text-zinc-400 mt-4 font-mono text-xs uppercase tracking-widest">{t.storefront.processing}</p>
          </>
        )}
        <div className="mt-4">
          <Link to={`/r/${slug}`} className="btn-outline" data-testid="back-to-restaurant-btn">
            <ChevronLeft className="w-4 h-4" /> {t.myOrders.backToRestaurant || t.storefront.backHome}
          </Link>
        </div>
      </div>
    </div>
  );
}
